export const baseApi = 'https://testbase2.cabinet.energy/admin'
